// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nrPN","delete":"styles_delete__2SQKG","update":"styles_update__1vT8v","add":"styles_add__1i4Iu"};